import { render, staticRenderFns } from "./approveBox.vue?vue&type=template&id=7dfaded5&scoped=true&"
import script from "./approveBox.vue?vue&type=script&lang=js&"
export * from "./approveBox.vue?vue&type=script&lang=js&"
import style0 from "./approveBox.vue?vue&type=style&index=0&id=7dfaded5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dfaded5",
  null
  
)

export default component.exports